import axios from 'axios'
import create, { GetState, SetState } from 'zustand'
import toast from 'react-hot-toast'
import { handleAxiosError } from '../utils/error'
import { Axios } from '../utils/axios'

type SettingsState = {
  loading: string
  user: any
  updateloading?: boolean
  getSettings: () => void
  getPolicies: () => void
}

const defaultState = {
  loading: 'idle'
}

const SettingsStore = (set: SetState<SettingsState>, get: GetState<SettingsState>) => ({
  ...defaultState,
  getSettings: async () => {
    set({ loading: 'loading' })
    try {
      const { data } = await Axios.get('/user')
      set({ user: data.data.user, loading: 'success' })
    } catch (error: any) {
      set({ loading: 'success' })
      handleAxiosError(error)
    }
  },
  updatePhone: async (phone_number: any) => {
    set({ updateloading: true })
    try {
      const { data } = await Axios.patch('/user', { phone_number })
      set({ user: data.data.user, updateloading: false })
      toast.success(data.message)
    } catch (error: any) {
      set({ updateloading: false })
      handleAxiosError(error)
    }
  }
})

const useSettingsStore = create<SettingsState>(SettingsStore)

export default useSettingsStore
